import { render, staticRenderFns } from "./alarm-msg.vue?vue&type=template&id=b3e231de&scoped=true"
import script from "./alarm-msg.vue?vue&type=script&lang=js"
export * from "./alarm-msg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e231de",
  null
  
)

export default component.exports